export const server = `https://b2i4nr8bza.execute-api.ap-south-1.amazonaws.com/Prod`;
